module.exports = __webpack_public_path__ + "img/FrogiGo_Site_Main.af134753.jpg";